<template lang="html">
  <div v-if="preferredLanguage && preferredUrl">
    <a :href="preferredUrl">{{ preferredLanguage }}</a>
    <b-dropdown position="is-bottom-left" v-if="languages.length > 2">
      <a slot="trigger">
        <b-icon icon="caret-down" type="is-black"/>
      </a>

      <b-dropdown-item v-for="language in languages" :key="language.code" has-link>
        <a :href="language.url">
          <span class="icon">
            <component :is="language.flag" height="32" width="20"/>
          </span> {{ language.name }}
        </a>
      </b-dropdown-item>
    </b-dropdown>
  </div>
</template>

<script>
import flags from './flags'

export default {
  props: {
    language: {type: String, default: window.__INIT_DATA.lang},
    items: {type: Array,
      default: () => {
        if(window.__INIT_DATA.recipe) return window.__INIT_DATA.recipe.languages
        if(window.__INIT_DATA.category) return window.__INIT_DATA.category.languages
        if(window.__INIT_DATA.menu) return window.__INIT_DATA.menu.languages
        return []
      }}
  },

  components: flags,

  computed: {
    currentLanguage(){
      return this.language.replace(/^(\w+?)(_.+|-.+|$)/, '$1').toLocaleLowerCase()
    },

    userLanguage(){
      return (navigator.language || navigator.userLanguage || 'de_at').replace(/^(\w+?)(_.+|-.+|$)/, '$1').toLocaleLowerCase()
    },

    preferredLanguage(){
      if(this.currentLanguage !== this.userLanguage){
        return this.$t(this.userLanguage)
      }
    },

    preferredUrl(){
      if(this.preferredLanguage){
        const language = this.items.filter(l => l.indexOf(this.userLanguage) === 0)[0]
        if(!language) return
        return `/${language}` + location.pathname.replace(new RegExp(`^/${this.language}/`), `/`)
      }
    },

    languages(){
      return this.items.map(k => {
        return {
          code: k,
          name: this.$t(k),
          flag: `${k.replace('_', '-')}-flag`,
          url: `/${k}` + location.pathname.replace(new RegExp(`^/${this.language}/`), `/`)
        }
      })
    }
  }
}
</script>

<i18n>
{
  "de_at": {
    "de_at": "Österreichisch?",
    "de_de": "Deutsch?",
    "de": "Deutsch?",
    "en": "english?",
    "fr": "français?",
    "cs": "češtině?",
    "hu": "magyarul?"
  },
  "cs": {
    "de_at": "Österreichisch?",
    "de_de": "Deutsch?",
    "de": "Deutsch?",
    "en": "english?",
    "fr": "français?",
    "cs": "češtině?",
    "hu": "magyarul?"
  },
  "hu": {
    "de_at": "Österreichisch?",
    "de_de": "Deutsch?",
    "de": "Deutsch?",
    "en": "english?",
    "fr": "français?",
    "cs": "češtině?",
    "hu": "magyarul?"
  },
  "fr": {
    "de_at": "Österreichisch?",
    "de_de": "Deutsch?",
    "de": "Deutsch?",
    "en": "english?",
    "fr": "français?",
    "cs": "češtině?",
    "hu": "magyarul?"
  }
}
</i18n>

<style lang="scss" scoped>
  .icon{
    margin-right: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/PreferredLanguage.vue